import { render } from "./VolumeFilter.vue?vue&type=template&id=83e0360c"
import script from "./VolumeFilter.vue?vue&type=script&lang=js"
export * from "./VolumeFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__